import React, { useEffect, useState } from 'react';
import { colorStyleMap, RICH_TYPE } from '@components/richEditor/configs';
import { Popover } from 'antd';
import { FontColorsOutlined } from '@ant-design/icons';
import { GithubPicker } from 'react-color';

function TextColorPicker({ toggleTextColorStyle, colorStyleMap }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // const closeDropdown = (e) => {
    //   setOpen(false);
    // };
    // document.addEventListener('click', closeDropdown);
    // return () => {
    //   document.removeEventListener('click', closeDropdown);
    // };
  }, []);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  return (
    <Popover
      overlayClassName="text-color-popover"
      content={
        <GithubPicker
          width={157}
          triangle="hide"
          colors={Object.keys(colorStyleMap)}
          onChangeComplete={(color) => {
            setOpen(false);
            toggleTextColorStyle(color);
          }}
        />
      }
      placement="bottom"
      title={() => null}
      trigger="click"
      visible={open}
      onOpenChange={handleOpenChange}
    >
      <div className="tool-btn with-antd-icon">
        <FontColorsOutlined
          onClick={(e) => {
            setOpen(true);
          }}
        />
      </div>
    </Popover>
  );
  // return (
  //   <div
  //     key={RICH_TYPE.TEXT_COLOR}
  //     className="tool-btn with-antd-icon"
  //     style={{ position: 'relative' }}
  //     onMouseDown={(e) => {
  //       e.preventDefault();
  //     }}
  //     onClick={(e) => {
  //       e.nativeEvent.stopImmediatePropagation();
  //       setOpen(!open);
  //     }}
  //   >
  //     <FontColorsOutlined />
  //     <div
  //       style={{
  //         position: 'absolute',
  //         zIndex: 10,
  //         top: open ? 28 : -10000,
  //         // left: -150,
  //       }}
  //     >
  //       <GithubPicker
  //         width={190}
  //         triangle={'hide'}
  //         colors={Object.keys(colorStyleMap)}
  //         onChangeComplete={(color) => {
  //           setOpen(false);
  //           toggleTextColorStyle(color);
  //         }}
  //       />
  //     </div>
  //   </div>
  // );
}

export default TextColorPicker;
